import useBeautyFilterImage from 'hooks/beautyFilter/useBeautyFilterImage';

// CancelItem
interface CancelItemProps {
  onClick: () => void;
}

export const CancelItem: React.FC<CancelItemProps> = ({ onClick }) => {
  const imgSrc = '/imgweb/beauty_filter/icons/block.svg';
  const { endLoadingImage } = useBeautyFilterImage(imgSrc);
  return (
    <div className="h-full w-[72px]" onClick={onClick}>
      <div className="flex h-[72px] w-[72px] items-center justify-center rounded-full bg-white/20 backdrop-blur-[32px]">
        <img src={imgSrc} alt="cancel" onLoad={() => endLoadingImage(imgSrc)} onError={() => endLoadingImage(imgSrc)} />
      </div>
    </div>
  );
};

// IconItem: Beauty, BeautySub, Makeup
interface IconItemProps {
  thumbnail: string;
  brscName?: string;
  brscSubName?: string;
  name?: string;
  isSelected?: boolean;
  isUsing?: boolean;
  onClick: () => void;
}

export const IconItem: React.FC<IconItemProps> = ({ thumbnail, brscName, brscSubName, name, isSelected, isUsing, onClick }) => {
  const { endLoadingImage } = useBeautyFilterImage(thumbnail);
  const displayName = (brscName ? brsc[brscName] : '') + ' ' + (brscSubName ? brsc[brscSubName] : '') + (name ? name : '');
  return (
    <div onClick={onClick} className="relative flex h-[104px] w-[72px] flex-col items-center gap-2">
      <div className="flex h-[72px] w-[72px] items-center justify-center rounded-full bg-white/20 backdrop-blur-[32px]">
        <img src={thumbnail} alt={displayName} onLoad={() => endLoadingImage(thumbnail)} onError={() => endLoadingImage(thumbnail)} />
      </div>
      <div className="typography-body-sm">{displayName}</div>
      {isSelected && <div className="absolute left-0 top-0 h-[72px] w-[72px] rounded-full border-2 border-solid border-[var(--green-200)] bg-transparent" />}
      {isUsing && <div className="absolute right-0 top-0 h-2 w-2 rounded-full bg-[var(--green-200)]" />}
    </div>
  );
};

// ThumbnailItem: MakeupSub, Mood, Background
interface ThumbnailItemProps {
  thumbnail: string;
  brscName?: string;
  name?: string;
  isSelected?: boolean;
  onClick: () => void;
}

export const ThumbnailItem: React.FC<ThumbnailItemProps> = ({ thumbnail, brscName, name, isSelected, onClick }) => {
  const { endLoadingImage } = useBeautyFilterImage(thumbnail);
  const displayName = (brscName ? brsc[brscName] : '') + (name ? name : '');
  return (
    <div onClick={onClick} className="relative flex h-[104px] w-[72px] flex-col items-center">
      <img
        src={thumbnail}
        alt={displayName}
        onLoad={() => endLoadingImage(thumbnail)}
        onError={() => endLoadingImage(thumbnail)}
        className="h-full w-[72px] rounded-sm object-cover"
      />
      <div className="typography-caption-body absolute bottom-0 flex h-[20px] w-[72px] items-center justify-center rounded-b-sm bg-black/50 backdrop-blur-[32px]">
        {displayName}
      </div>
      {isSelected && <div className="absolute left-0 top-0 h-[104px] w-[72px] rounded-sm border-2 border-solid border-[var(--green-200)] bg-transparent" />}
    </div>
  );
};

// StickerItem
interface StickerItemProps {
  id: string;
  thumbnail: string;
  isSelected?: boolean;
  onClick: () => void;
}

export const StickerItem: React.FC<StickerItemProps> = ({ id, thumbnail, onClick, isSelected }) => {
  const { endLoadingImage } = useBeautyFilterImage(thumbnail);
  return (
    <div onClick={onClick} className="relative flex h-[72px] w-[72px] flex-col items-center">
      <img src={thumbnail} alt={id} onLoad={() => endLoadingImage(thumbnail)} onError={() => endLoadingImage(thumbnail)} className="h-full w-[72px] rounded-sm" />
      {isSelected && <div className="absolute left-0 top-0 h-[72px] w-[72px] rounded-sm border-2 border-solid border-[var(--green-200)] bg-transparent" />}
    </div>
  );
};
